module.exports = __webpack_public_path__ + "43d9c3efee13a6a00d23b55b844a03b5.svg";